import { StyleSheet, View, Text } from '@react-pdf/renderer'
import React from 'react'

const TableFooter: React.FC = () => {

    const styles = StyleSheet.create({
        container: {
            position: 'absolute',
            bottom: '28px',
            left: '20px',
            right: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%',
            borderTop: '1px solid black',
        },
        leftText: {
            fontSize: '8px',
        },
        rightText: {
            fontSize: '8px',
            fontWeight: 'bold',
        }
    })


    return(
<>
<View  fixed style={{
            position: 'absolute',
            bottom: '50px',
            left: '20px',
            right: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%'}}>

<Text style={{fontSize:'8px', position: 'absolute', left: '40%'}} >049_FMEI Rev.03 - Apr. Nov/20</Text>
</View>
    <View style = {styles.container} fixed>
        <Text style = {styles.leftText} render={({ pageNumber, totalPages }) => (`pág ${pageNumber} de ${totalPages}`)} fixed />
    </View>

        </>
    )

}

export default TableFooter